(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-p2c-contact-track]').forEach((track) => {
      if (track.dataset.ready === 'true') return;
      const section = track.closest('section');
      const cards = [...track.querySelectorAll('[data-p2c-contact-card]')];
      const dots = [...section.querySelectorAll('[data-p2c-contact-dot]')];
      if (cards.length < 2 || dots.length < 2) return;
      track.dataset.ready = 'true';

      const update = () => {
        const left = track.getBoundingClientRect().left;
        let active = 0;
        let best = Infinity;
        cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - left);
          if (distance < best) {
            best = distance;
            active = index;
          }
        });
        dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
      };

      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
      }, { passive: true });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          cards[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      });

      update();
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
